export enum DesmyState {
    LOADING = "LOADING",
    ERROR = "ERROR",
    SUCCESS="SUCCESS",
    APPROVED="APPROVED",
    SUBMITTED="SUBMITTED",
    CONFIRMED="CONFIRMED",
    STARTED="STARTED",
    ACTIVE="ACTIVE",
    LOADED = "LOADED",
    RUNNING="RUNNING",
    ADMITTED="ADMITTED",
    ADMIT="ADMIT",
    UPDATED="UPDATED",
    NO="NO",
    YES="YES",
    COURSE_ALLOCATION="COURSE_ALLOCATION",
    ELECTIVE="ELECTIVE",
    CORE="CORE",
    NOTIFICATION="NOTIFICATION",
    NOTIFICATION_ALERT="NOTIFICATION_ALERT",
    NOTIFICATION_ALERT_CLOSE="NOTIFICATION_ALERT_CLOSE",
    HEALTHY = "HEALTHY",
    UNHEALTHY = "UNHEALTHY",
    TEACHING="TEACHING",
    NONTEACHING="NONTEACHING",
    STUDENTS = "STUDENTS",
    APPLICANTS = "APPLICANTS",
    PROGRAMMES = 'PROGRAMMES',
    APPOINTMENT="APPOINTMENT",
    UNITS="UNITS",
    SUBGROUPS="SUBGROUPS",
    CURRICULUM="CURRICULUM",
    EXAMINATIONS="EXAMINATIONS",
    LEAVE="LEAVE",
    ORGANIZATIONAL_UNITS="ORGANIZATIONAL_UNITS",
    PROGRESS="PROGRESS",
    COMPLETED="COMPLETED",
    QUALIFIED = "QUALIFIED",
    WAITING = "WAITING",
    PENDING="PENDING",
    IN_PROGRESS="IN_PROGRESS",
    CIRRICULUM="CIRRICULUM",
    NOTICE="NOTICE",
    OPEN = "OPEN",
    ACCESS_TOKEN = "access_token",
    APPLICATION_ACCESS_TOKEN="a_token",
    APPLICATION="APPLICATION",
    APPLY_AS_AWAITING="APPLY_AS_AWAITING",
    UPLOAD_RESULTS="UPLOAD_RESULTS",
    TEXT = "TEXT",
    TEXTAREA="TEXTAREA",
    EMAIL = "EMAIL",
    PHONE = "PHONE",
    NUMBER = "NUMBER",
    PASSWORD = "PASSWORD",
    DOCUMENT="DOCUMENT",
    EDIT="EDIT",
    DELETE="DELETE",
    ACADEMIC="ACADEMIC",
    NONACADEMIC="NONACADEMIC",
    INTERNATIONAL="INTERNATIONAL",
    VOUCHER_PARAM="VOUCHER_PARAM",
    VOUCHER="VOUCHER",
    EMAIL_ADDRESS="EMAIL_ADDRESS",
    MOBILE_MONEY="MOBILE_MONEY",
    LOCAL="LOCAL",
    FRONT="FRONT",
    ADMISSION="ADMISSION",
    MEDIA_CAPTURED="MEDIA_CAPTURED",
    FEMALE="FEMALE",MALE="MALE",
    DATASETTABLE_REQUEST="DATASETTABLE_REQUEST",
    SMALL="SMALL",NORMAL="NORMAL",LARGE="LARGE",
    AGGREGATE="AGGREGATE",
    AUTOMATIC="AUTOMATIC",
    MANUAL = "MANUAL",
    INTERVIEW="INTERVIEW",
    ENTRANCE_EXAMS="ENTRANCE_EXAMS",
    REJECT="REJECT",
    SYSTEM_GET_STARTED="SYSTEM_GET_STARTED",
    COURSE_POLICY="COURSE_POLICY",
    REJECTED="REJECTED",
    COURSES="COURSES",
    GRADE_CUT_OF_POINT_STATE = "GRADE_CUT_OF_POINT_STATE",
    AGGREGATE_CUT_OF_POINT_STATE = "AGGREGATE_CUT_OF_POINT_STATE",
    GENDER_CUT_OF_POINT_STATE = "GENDER_CUT_OF_POINT_STATE",
    MATURE_INVITATION = "MATURE_INVITATION",
    RESULTS = "RESULTS",
    FILE_UPLOAD="FILE_UPLOAD",
    COURSE_REMOVED="COURSE_REMOVED",
    COURSE_ADDED="COURSE_ADDED",
    RECOMMENDATION_LETTER="RECOMMENDATION_LETTER",
    ERROR_MESSAGE= "Sorry for the inconvenience caused by the error. Please contact us if the issue persists. ",
    POSITIONS="POSITIONS",
    WASSCE_RESULTS="WASSCE_RESULTS",
    NEW_SITTING="NEW_SITTING",
    REFEREE="REFEREE",
    CERTIFICATE="CERTIFICATE",
    TRANSCRIPT="TRANSCRIPT",
    CERTIFICATES_AND_TRANSCRIPTS="CERTIFICATES_AND_TRANSCRIPTS",
    RECOMMENDATION_LETTERS="RECOMMENDATION_LETTERS",
    SECONDARY_SCHOOL_DOCUMENTS="SECONDARY_SCHOOL_DOCUMENTS",
    UPDATE_INFORMATION="UPDATE_INFORMATION",
    SUB_CAMPUSES="SUB_CAMPUSES",
    VOUCHER_FEES="VOUCHER_FEES",
    REPORT="REPORT",
    NEW_DOCUMENT="NEW_DOCUMENT",
    OTHERS="OTHERS",
    REGULAR="REGULAR",
    INTERNAL="INTERNAL",
    EXTERNAL="EXTERNAL",
    COLOR="COLOR",
    SEARCH="SEARCH",
    IMMEDIATELY="IMMEDIATELY",
    CUSTOM="CUSTOM",
    ACTING="ACTING",
    SUBSTANTIAL="SUBSTANTIAL",

    UPLOAD_MANAGER_REQUEST="UPLOAD_MANAGER_REQUEST"
}